import { ContiguousTimeslot, TimeslotId, Timeslot } from "../timeslots.types";
import { groupTimeslotsByDay } from "./groupTimeslotsByDay";

/**
 * Finds contiguous blocks of selected time slots by adjacent IDs.
 * Groups by date string (ISO format) rather than day-of-week index.
 * Returns blocks with inclusive start and exclusive end slot IDs,
 * plus an array of included slot IDs.
 */
export function findContiguousTimeslots(
  selected: Timeslot[]
): ContiguousTimeslot[] {
  const blocks: ContiguousTimeslot[] = [];

  const slotsByDay = groupTimeslotsByDay(selected);

  for (const [dateString, daySlots] of Object.entries(slotsByDay)) {
    // Get dayIndex from the first slot in this group
    const day = daySlots[0]?.local.start.dayIndex ?? 0;
    const sorted = [...daySlots].sort((a, b) => a.id - b.id);

    let blockStart = 0;

    for (let i = 1; i <= sorted.length; i++) {
      const prev = sorted[i - 1];
      const curr = sorted[i];

      const isEndOfBlock = !curr || curr.id !== prev.id + 1;

      if (isEndOfBlock) {
        const start = sorted[blockStart];
        const end = sorted[i - 1];

        const slotIds = sorted
          .slice(blockStart, i)
          .map((slot) => slot.id as TimeslotId);

        const duration = (slotIds.length * 30) / 60;

        blocks.push({
          day,
          dateString,
          duration,
          startTimeSlotId: start.id,
          endTimeSlotId: (end.id < 335 ? end.id + 1 : end.id) as TimeslotId,
          slotIds,
        });

        blockStart = i;
      }
    }
  }

  // Sort by dateString first, then by startTimeSlotId
  return blocks.sort((a, b) => {
    if (a.dateString !== b.dateString) {
      return a.dateString.localeCompare(b.dateString);
    }
    return a.startTimeSlotId - b.startTimeSlotId;
  });
}

export default findContiguousTimeslots;

